<template>
  <v-flex xs12 sm10 md6 xl4>
    <div class="vertical-center-container">
      <div class="mr-3" v-if="page == 'trips' || page == 'rctis' || page == 'bills' || page == 'approvedBillLines'">
        <v-select
          label="Select action"
          :items="fieldsToChange"
          v-model="fieldToChange"
          item-value="value"
          return-object
          prepend-inner-icon="list"
          clearable
          :clear-icon-cb="clearFieldToChange"
          :color="$store.state.global.pages.docket.color"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-action>
              <v-icon :color="data.item.color">{{ data.item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ data.item.text }}</v-list-tile-title>
          </template>
          <template slot="selection" slot-scope="data">
            <!-- <v-icon small :color="data.item.color" class="mr-3">
                            {{ data.item.icon }}
            </v-icon>-->
            {{ !!selectedCount ? `${data.item.text} for ${selectedCount} ${page}` : `${data.item.text}`}}
          </template>
        </v-select>
      </div>
      <div>
        <v-btn
          :color="$store.state.global.pages[this.$route.name].color"
          flat
          @click="confirmAction()"
        >
          Confirm
          <!-- <v-icon right>save_alt</v-icon> -->
        </v-btn>
      </div>

      <!-- PDF CONFIRMATION -->
      <v-dialog
        v-model="pdfInvoiceDialog"
        max-width="700px"
        @keydown.esc="pdfInvoiceDialog = false"
        lazy
      >
        <make-pdf :page="page" :selectedCount="selectedCount"></make-pdf>
      </v-dialog>

      <!-- DIALOG CONFIRMATION -->
      <v-dialog
        v-model="dialog"
        max-width="700px"
        @keydown.esc="dialog = false"
        lazy
        v-if="userAuthClass"
      >
        <v-card>
          <v-card-title class="headline">
            <layout-no-padding>
              <v-flex xs12>
                <span>
                  {{ fieldToChange.text}} for Selected {{page}}?
                  <span class="grey--text subheading"></span>
                </span>
              </v-flex>
              <v-flex
                xs12
                class="grey--text title"
              >This action will affect {{selectedCount}} {{pageSingular}}(s).</v-flex>
            </layout-no-padding>
          </v-card-title>
          <v-form @submit.prevent="setSelectedTrips()">
            <v-card-text>
              <v-flex
                xs12
                v-if="($route.name == 'rcti' || $route.name == 'billing') && (fieldToChange.text == 'Update RCTI Status' || fieldToChange.text == 'Update Bill Status')"
              >
                <v-select
                  label="Status"
                  v-model="status"
                  prepend-icon="info"
                  :items="statusItems"
                  type="text"
                ></v-select>
              </v-flex>
              <v-text-field label="Notes" v-model="notes"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" flat @click="dialog = false">No</v-btn>
              <v-btn color="green darken-1" flat type="submit" :loading="loading">Yes</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <!-- EXPORT ***XERO RCTI*** DIALOG CONFIRMATION -->
      <v-dialog v-model="exportDialog" max-width="400px" @keydown.esc="exportDialog = false" lazy>
        <make-csv
          :selected="selected"
          @close="exportDialog = false"
          :selectedAll="selectedAll"
        ></make-csv>
      </v-dialog>

      <!-- DELETE RCTI DIALOG CONFIRMATION -->
      <v-dialog
        v-model="deleteRctisDialog"
        max-width="400px"
        @keydown.esc="deleteRctisDialog = false"
        lazy
      >
        <rcti-delete-multiple :selected="this.selected" @close="deleteRctisDialog = false"></rcti-delete-multiple>
      </v-dialog>

      <v-dialog
        v-model="deleteApprovedBillLinesDialog"
        max-width="400px"
        @keydown.esc="deleteApprovedBillLinesDialog = false"
        lazy
      >
        <approved-bill-lines-delete-multiple :pagination="pagination" :selected="this.selected" @close="deleteApprovedBillLinesDialog = false"></approved-bill-lines-delete-multiple>
      </v-dialog>


      <v-dialog
        v-model="batchRepriceDialog"
        max-width="400px"
        @keydown.esc="batchRepriceDialog = false"
        lazy
      >
        <batch-reprice
          :selected="selected"
          :selectedCount="selectedCount"
          :selectedAll="selectedAll"
          @close="batchRepriceDialog = false"
        ></batch-reprice>
      </v-dialog>

      <!-- UPDATE STATUS DIALOG CONFIRMATION -->
      <!-- <v-dialog v-model="statusDialog" max-width="400px" @keydown.esc="statusDialog = false" lazy v-if="userAuthClass">       
                <v-card>
                    <v-card-title class="headline"><span>Export selected documents?<span class="grey--text subheading"></span></span></v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" flat @click="statusDialog = false">
                            No
                        </v-btn>
                        <v-btn :color="primaryNeutral" flat @click="statusDialog = false">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
      </v-dialog>-->
    </div>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'
import RctiService from '@/services/requests/rctiService'
import BillService from '@/services/requests/billService'
// import jsPDF from 'jspdf'
// import autoTable from 'jspdf-autotable'
import FormatDates from '@/services/mixins/formatDates'
import BuildTripQuery from '@/services/mixins/buildTripQuery'
import MakePdf from './makePdf'
import MakeCsv from './makeCsv'
import RctiDeleteMultiple from '@/components/rctis/rctiDeleteMultiple'
import ApprovedBillLinesDeleteMultiple from '@/modules/approvedBillLines/approvedBillLinesDeleteMultiple'
import BatchReprice from '@/components/trips/actions/batchReprice'
export default {
  components: {
    MakePdf,
    MakeCsv,
    RctiDeleteMultiple,
    BatchReprice,
    ApprovedBillLinesDeleteMultiple
  },
  mixins: [FormatDates, BuildTripQuery],
  data() {
    return {
      pageSingular: this.page.substring(0, this.page.length - 1),
      dialog: false,
      fieldToChange: {},
      status: 'ENTERED',
      statusItems: [
        'ENTERED',
        'COMMITED',
        'REVIEW',
        'APPROVED',
        'SENT',
        'CLOSED'
      ],
      exportDialog: false,
      exportTripsDialog: false,
      deleteRctisDialog: false,
      deleteApprovedBillLinesDialog: false,
      batchRepriceDialog: false,
      //statusDialog: false,
      //xeroCsvArray: [],
      tripFieldsToChange: [
        {
          text: 'Confirm GPS data',
          icon: 'gps_fixed',
          color: 'green lighten-2',
          value: {
            field: 'GPSConfirmed',
            value: 'CONFIRMED',
            text: 'Confirm GPS data',
            label: 'GPS'
          }
        },
        {
          text: 'Review GPS data',
          icon: 'gps_fixed',
          color: 'orange lighten-2',
          value: {
            field: 'GPSConfirmed',
            value: 'REVIEW',
            text: 'Review GPS data',
            label: 'GPS'
          }
        },
        {
          text: 'Unconfirm GPS data',
          icon: 'gps_not_fixed',
          color: 'grey',
          value: {
            field: 'GPSConfirmed',
            value: 'NOT SET',
            text: 'Un-confirm GPS data',
            label: 'GPS'
          }
        },
        {
          text: 'Confirm Tipping Docket',
          icon: 'delete_sweep',
          color: 'green lighten-2',
          value: {
            field: 'tippingDocketConfirmed',
            value: 'CONFIRMED',
            text: 'Confirm Tipping Docket',
            label: 'tippingDocket'
          }
        },
        {
          text: 'Review Tipping Docket',
          icon: 'delete_sweep',
          color: 'orange lighten-2',
          value: {
            field: 'tippingDocketConfirmed',
            value: 'REVIEW',
            text: 'Review Tipping Docket',
            label: 'tippingDocket'
          }
        },
        {
          text: 'Unconfirm Tipping Docket',
          icon: 'delete_sweep',
          color: 'grey',
          value: {
            field: 'tippingDocketConfirmed',
            value: 'NOT SET',
            text: 'Unconfirm Tipping Docket',
            label: 'tippingDocket'
          }
        },
        {
          text: 'Confirm Mass Declaration',
          icon: 'shopping_basket',
          color: 'green lighten-2',
          value: {
            field: 'massDeclarationConfirmed',
            value: 'CONFIRMED',
            text: 'Confirm Mass Declaration',
            label: 'massDeclaration'
          }
        },
        {
          text: 'Create PDFs',
          icon: 'picture_as_pdf',
          color: 'grey',
          value: { value: null, text: 'Create PDFs', label: 'pdfs' }
        },
        {
          text: 'Reprice',
          icon: this.$store.state.global.pages.rate.icon,
          color: 'grey',
          value: { value: null, text: 'Reprice', label: 'reprice' }
        },
        {
          text: 'Export Selected',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Export Selected', label: 'export' }
        }
      ],
      rctiFieldsToChange: [
        {
          text: 'Update RCTI Status',
          icon: 'info',
          color: 'green lighten-2',
          value: {
            value: 'ENTERED',
            text: 'Update RCTI Status',
            label: 'status'
          }
        },
        {
          text: 'Confirm Stat Dec data',
          icon: 'file_copy',
          color: 'green lighten-2',
          value: {
            value: 'CONFIRMED',
            text: 'Confirm Stat dec. data',
            label: 'statDec'
          }
        },
        {
          text: 'Flag Stat Dec data for review',
          icon: 'file_copy',
          color: 'orange lighten-2',
          value: {
            value: 'REVIEW',
            text: 'Review Stat dec. data',
            label: 'statDec'
          }
        },
        {
          text: 'Unconfirm Stat dec data',
          icon: 'file_copy',
          color: 'grey',
          value: {
            value: 'NOT SET',
            text: 'Un-confirm Stat dec. data',
            label: 'statDec'
          }
        },
        {
          text: 'Create PDFs',
          icon: 'picture_as_pdf',
          color: 'grey',
          value: { value: null, text: 'Create PDFs', label: 'pdfs' }
        },
        {
          text: 'Export Selected (CSV)',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Export Selected (CSV)', label: 'export' }
        },
        {
          text: 'Delete Selected RCTIs',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Delete Selected RCTIs', label: 'delete' }
        }
      ],
      billFieldsToChange: [
        {
          text: 'Update Bill Status',
          icon: 'file_copy',
          color: 'green lighten-2',
          value: {
            value: 'ENTERED',
            text: 'Update Bill Status',
            label: 'status'
          }
        },
        // {
        //     text: "Confirm Option?? data",
        //     icon: "file_copy",
        //     color: "green lighten-2",
        //     value: {value: "CONFIRMED", text: "Confirm data", label: "option"}
        // },
        // {
        //     text: "Flag Option?? data for review",
        //     icon: "file_copy",
        //     color: "orange lighten-2",
        //     value: {value: "REVIEW", text: "Review data", label: "option"}
        // },
        // {
        //     text: "Un-confirm Option?? data",
        //     icon: "file_copy",
        //     color: "grey",
        //     value: {value: "NOT SET", text: "Un-confirm  data", label: "option"}
        // },
        {
          text: 'Create PDFs',
          icon: 'picture_as_pdf',
          color: 'grey',
          value: { value: null, text: 'Create PDFs', label: 'pdfs' }
        },
        {
          text: 'Export Selected (CSV)',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Export Selected (CSV)', label: 'export' }
        }
      ],
      approvedBillLineFieldsToChange: [
        {
          text: 'Export Selected (CSV)',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Export Selected (CSV)', label: 'export' }
        },
        {
          text: 'Delete Selected Approved Bill Lines',
          icon: 'import_export',
          color: 'grey',
          value: { value: null, text: 'Delete Selected Approved Bill Lines', label: 'deleteApprovedBill' }
        }
      ],
      notes: '',
      loading: false
    }
  },
  methods: {
    clearFieldToChange() {
      this.fieldToChange = {}
    },
    confirmAction() {
      if (!this.selectedCount) {
        this.snack({ color: 'yellow', text: 'No documents are selected!' })
        this.dialog = false
        return
      }
      if (!Object.keys(this.fieldToChange).length) {
        this.snack({ color: 'yellow', text: 'No action was selected!' })
        this.dialog = false
        return
      } else {
        if (this.fieldToChange.text == 'Create PDFs') {
          this.pdfInvoiceDialog = true
          //this.makeInvoicePdfs(this.selected)
        } else if (this.fieldToChange.value.label == 'export') {
          this.exportDialog = true
        } else if (this.fieldToChange.value.label == 'delete') {
          this.deleteRctisDialog = true
        } else if (this.fieldToChange.value.label == 'deleteApprovedBill'){ 
          this.deleteApprovedBillLinesDialog = true
        }
        else if (this.fieldToChange.value.label == 'reprice') {
          if (!this.$store.getters['user/isAdmin']) {
            return this.snack({
              color: 'red',
              text: 'You are not authorised to carry out this action.'
            })
          }
          this.batchRepriceDialog = true
        } else {
          this.dialog = true
        }
      }
    },

    setSelectedTrips() {
      if (!this.selectedCount) {
        this.snack({ color: 'yellow', text: 'No documents are selected!' })
        return
      }
      if (!Object.keys(this.fieldToChange).length) {
        this.snack({ color: 'yellow', text: 'No action was selected!' })
        return
      } else {
        this.update(this.selected)
      }
    },
    update(selected) {
      selected = selected.map(item => item.id)
      if (this.$route.name == 'docket') {
        this.updateTrips(selected)
      } else if (this.$route.name == 'rcti') {
        this.updateRctis(selected)
      } else {
        this.updateBills(selected)
      }
    },
    updateTrips(trips) {
      this.loading = true
      var updateTripsData = {
        field: this.fieldToChange.value.field,
        notesField: `${this.fieldToChange.value.label}Notes`,
        notes: this.notes,
        value: this.fieldToChange.value.value
      }
      if (this.selectedAll) {
        //BUILD QUERY IF MODIFYING ALL TRIPS
        updateTripsData.query = this.buildQuery()
      } else {
        //SET TRIP IDS ARRAY IF MODIFYING SELECT TRIPS
        updateTripsData.trips = trips
      }
      //console.log(updateTripsData)
      DocketService.updateTrips(updateTripsData)
        .then(result => {
          //console.log(result);
          for (var trip of result.data.result.trips) {
            this.$store.commit('trips/updateArrayStateById', {
              prop: 'trips',
              editedValue: trip
            })
          }
          this.notes = ''
          this.loading = false
          this.dialog = false
          this.selectedTrips = []
          this.snack({
            color: 'green',
            text: `${result.data.result.affectedRows} Trips were updated`
          })
        })
        .catch(err => {
          this.loading = false
          this.snackError()
          console.log(err)
        })
    },

    updateRctis(ids) {
      this.loading = true
      var updateData = {
        ids,
        field: `${this.fieldToChange.value.label}Confirmed`,
        notesField: `${this.fieldToChange.value.label}Notes`,
        notes: this.notes,
        value: this.fieldToChange.value.value
      }

      if (this.fieldToChange.value.label == 'status') {
        updateData.field = 'status'
        updateData.notesField = 'internalNotes'
        updateData.value = this.status
      }
      //console.log("RCTI Data: ",updateData);

      RctiService.updateRctis(updateData)
        .then(result => {
          //console.log(result);
          for (var rcti of result.data.result.rctis) {
            this.$store.commit('rctis/updateArrayStateById', {
              prop: 'rctis',
              editedValue: rcti
            })
          }
          this.notes = ''
          this.loading = false
          this.dialog = false
          this.selectedRctis = []
          this.snack({ color: 'green', text: 'RCTIs were updated' })
        })
        .catch(err => {
          this.loading = false
          this.snackError()
          console.log(err)
        })
    },
    updateBills(ids) {
      this.loading = true
      var updateData = {
        ids,
        field: `${this.fieldToChange.value.label}Confirmed`,
        notesField: `${this.fieldToChange.value.label}Notes`,
        notes: this.notes,
        value: this.fieldToChange.value.value
      }
      if (this.fieldToChange.value.label == 'status') {
        updateData.field = 'status'
        updateData.notesField = 'internalNotes'
        updateData.value = this.status
      }

      BillService.updateBills(updateData)
        .then(result => {
          //console.log(result);
          for (var bill of result.data.result.bills) {
            this.$store.commit('bills/updateArrayStateById', {
              prop: 'bills',
              editedValue: bill
            })
          }
          this.notes = ''
          this.loading = false
          this.dialog = false
          this.selectedBills = []
          this.snack({ color: 'green', text: 'Bills were updated' })
        })
        .catch(err => {
          this.loading = false
          this.snackError()
          console.log(err)
        })
    }
  },
  props: {
    page: String,
    selectedCount: Number,
    pagination: Object
  },
  computed: {
    //billingPeriod: Store.getSet({store: 'shared', prop: 'billingPeriod'}),
    pdfInvoiceDialog: Store.getSet({
      store: 'shared',
      prop: 'pdfInvoiceDialog'
    }),
    selected: {
      get() {
        return this.$store.state[this.page].selected
      },
      set(val) {
        this.$store.commit(`${this.page}/setState`, {
          prop: 'selected',
          value: val
        })
      }
    },
    selectedAll() {
      return this.$store.state[this.page].selectedAll
    },
    fieldsToChange() {
      return this[`${this.pageSingular}FieldsToChange`]
    }
  }
}
</script>

<style>
</style>
